import React from 'react';
import { propTypes, withFormsy } from 'formsy-react';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField, InputLabel, FormHelperText } from '@mui/material';
import _ from 'lodash';

export class AutocompleteInput extends React.Component {
  constructor(props) {
    super(props);

    this.changeValue = this.changeValue.bind(this);
    this.getOptionLabel = this.getOptionLabel.bind(this);
  }

  changeValue(event, valueObject) {
    const { onChange, setValue } = this.props;
    if (onChange) onChange(valueObject.value);
    setValue(valueObject.value);
  }

  getOptionLabel(option) {
    return option.label || _.find(this.props.options, (o) => { return o.value == option }).label;
  }

  render() {
    const { name, label, required, options, disabled, hint, value, errorMessage, isPristine, classes } = this.props;
    const isError = !isPristine && errorMessage != null;

    return (
      <div className="input-container">
        <Autocomplete
          id={name}
          fullWidth
          onChange={this.changeValue}
          value={value || null}
          options={options}
          renderInput={(params) => <TextField {...params} label={label} required={required} error={isError} />}
          getOptionLabel={this.getOptionLabel}
          disabled={disabled}
        />

        <span aria-live="polite">
          {!isPristine && errorMessage &&
            <FormHelperText error={isError}>{errorMessage}</FormHelperText>
          }
        </span>
        {hint &&
          <FormHelperText>{hint}</FormHelperText>
        }
      </div>
    );
  }
}

AutocompleteInput.propTypes = {
  ...propTypes
};

export default withFormsy(AutocompleteInput);
